import clsx from 'clsx';
import React from 'react';

import { useEventTracking } from '@hooks';
import { edit_profile_settings_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import styles from './styles.module.scss';

const UPDATE_YOUR_PROFILE = 'Update your profile';

export default function UpdateProfileButton() {
  const { trackEvent } = useEventTracking();

  const handleClickTracking = () => {
    trackEvent(
      click({
        clickLink: edit_profile_settings_path(),
        clickTarget: ClickTarget.UpdateProfileButton,
        clickText: UPDATE_YOUR_PROFILE,
      })
    );
  };

  return (
    <div className={styles.updateProfileBtnWrapper}>
      <a
        href={edit_profile_settings_path()}
        className={clsx(styles.btn, styles.updateProfileBtn)}
        onClickCapture={handleClickTracking}
      >
        {UPDATE_YOUR_PROFILE}
      </a>
    </div>
  );
}
